import { Module, VuexModule, Action } from 'vuex-module-decorators';

import {
  BASE_URL,
  TRANSFER,
  WITHDRAW,
  M_POST,
} from '@/utils/api';

import Vue from 'vue';

@Module({ name: 'balance' })
export default class Balance extends VuexModule {
  @Action
  Refill(param) {
    const path = param.type === 'TRANSFER' ? TRANSFER : WITHDRAW;
    return Vue.axios({
      url: BASE_URL + path,
      data: param,
      method: M_POST,
    })
      .then(({ data }) => data.status)
      .catch((err) => err);
  }
}
